import React from "react";
import RoleRoute from "./RoleRoute";

const ADMIN_ROLES = ["admin", "adminStaff"];

const ProtectedRoute = ({ isAdmin, superOnly, ...rest }) => (
    <RoleRoute roles={superOnly === true ? ["admin"] : ADMIN_ROLES} {...rest} />
);

export default ProtectedRoute;
